import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["src"]

import { computed } from 'vue'
import live from '@/assets/svg/live.svg'
import MsButton from '@/components/general/buttons/MsButton.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'LiveButton',
  props: {
  isActive: Boolean
},
  setup(__props) {

const props = __props

const buttonClassStyle = computed(() => `btn-filter ${props.isActive ? 'active' : ''}`)

const buttonFontStyle = computed(() => `${props.isActive ? 'NKT-P2-medium' : 'NKT-P2'}`)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(MsButton, {
      "button-custom-style": buttonClassStyle.value,
      "button-font": buttonFontStyle.value
    }, {
      default: _withCtx(() => [
        (__props.isActive)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _unref(live),
              class: "icon"
            }, null, 8, _hoisted_1))
          : _createCommentVNode("", true),
        _cache[0] || (_cache[0] = _createTextVNode(" LIVE "))
      ]),
      _: 1
    }, 8, ["button-custom-style", "button-font"])
  ]))
}
}

})